<template>
  <div>
  <v-expansion-panels v-model="panel" :readonly="!painel" flat class="mt-5 white mb-5">
    <v-expansion-panel>
        <v-expansion-panel-header class="display-flex pl-1 pr-3" style="border-bottom: solid 1px #eee;" hide-actions>           
          <h5 class="black--text"  @click="expansionPanelOpenCloseControl()" >
            <i class="aberto v-icon notranslate mdi mdi-chevron-down theme--light primary--text"></i>
            <i class="fechado v-icon notranslate mdi mdi-chevron-right theme--light primary--text"></i>
            <span class="mt-5 ml-2">Histórico</span>
          </h5>
          <!-- <div class="text-right display-flex historico-header-actions aberto" style="max-width: 90%; display: flex !important; flex-direction: row !important; justify-content: space-between !important;">
            
            <button
              :class="'btn ' + ((atualizacoesHistorico) ?  'btn-danger' : 'btn-outline-danger')"
              v-b-tooltip.top
              title="Filtrar atualizações de histórico"
              style="
                margin-left: 10px;
                margin-right: 10px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;" 
              @click="filtrarAtualizacoesDeHistorico">
                <span>
                  <v-icon>mdi-filter-variant</v-icon>
                  Filtrar atualizações de histórico
                </span>
            </button>

            <v-menu
              open-on-hover
              bottom
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <button
                  :class="'aberto btn ' +  ((atualizacoesHistorico || formSeletores.exibir_historico_completo) ? 'btn-danger' : 'btn-outline-danger')"
                  style="letter-spacing: 0.0892857143em; border-radius: 28px; margin-top: 1px; font-size: 14px !important;"
                  v-bind="attrs"
                  v-on="on"
                >
                <v-icon color="grey">mdi-filter-variant</v-icon>
                <span style="margin-left: 5px; font-weight: 400;">Filtrar Tratativas</span>
                </button>
              </template>
              <v-list>
                <v-list-item>
                    <SGPFormToggleComponent color="primary" class="aberto toogle-historico primary--text ml-3" name="atualizacao_historico" titulo="Atualizações de Histórico"
                    :value="atualizacoesHistorico" @click="filtrarAtualizacoesDeHistorico"></SGPFormToggleComponent>
                </v-list-item>
                <v-list-item>
                    <SGPFormToggleComponent color="primary" class="aberto toogle-historico primary--text ml-3" name="exibir_historico_completo" titulo="Tratativas Sistêmicas"
            :value="formSeletores.exibir_historico_completo" @click="switchExibirHistoricoCompleto"></SGPFormToggleComponent>
                </v-list-item>
              </v-list>
            </v-menu>

            <SGPFormBotaoComponent 
              class="aberto"
              @click="abrirFiltroAvancadoHistorico"
              outlined
            >
              <v-icon color="grey">mdi-filter</v-icon>
              <span style="font-weight: 400;">Filtro Avançado</span>
            </SGPFormBotaoComponent>

            <div class="display-flex mt-3">
              <SGPFormInputComponent 
                append-icon="mdi-magnify"
                x-small
                type="text"
                v-model="buscaHistorico"
                placeholder="Digite o que deseja buscar..."
                outlined
                dense
                rounded
                solo
                class="aberto input-busca-historico"
                style="width: 300px;"
              />
              <SGPFormBotaoComponent  color="white"  class="float-right ml-3 aberto" @click="search">
                <SGPIconComponent class="" />
                  Buscar
              </SGPFormBotaoComponent>
            </div>

            <v-icon 
              :color="!openAll ? 'primary' : 'grey'"
              @click="openAllHistory"
            >
              mdi-eye
            </v-icon>
          </div> -->

        </v-expansion-panel-header>
        <v-expansion-panel-content class="pa-3">
          <div v-if="listaDeHistorico.length === 0" class="text-center pa-5">
            <v-icon size="64" color="grey lighten-1">mdi-history</v-icon>
            <p class="grey--text mt-3">Nenhum histórico encontrado</p>
          </div>
          <SGPTimelineHistoricoComponent v-else :items="listaDeHistorico"/>
          <div class="d-flex justify-content-center pa-2">
            <SGPFormBotaoComponent @click="carregarMaisHistorico" v-if="exibeCarregarMais">
              Carregar Mais
            </SGPFormBotaoComponent>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- <SGPDrawerComponent
      v-model="abrirFiltroAvancado"
      class="pt-15"
      width="400"
      fixed
    >
      <SGPFiltroComponent>
        <template v-slot:form>
          <SGPFormFilterComponent
            v-if="camposFiltrosComputed.length"
            :key="camposFiltrosComputed"
            :campos="camposFiltrosComputed"
            @sgpFormFilterDadosClick="aplicarFiltro"
            @sgpFormFilterLimpar="limparFormFilter"
          >
            <SGPRowComponent no-gutters>
              <div class="col-sm-12 mb-6">
                <SGPFormDataComponent
                  name="data_inicio"                    
                  placeholder="Data Início" 
                  :time="false"           
                  v-model="formSeletores.data_inicio"
                />
              </div>
            </SGPRowComponent>
            <SGPRowComponent no-gutters>
              <div class="col-sm-12 mb-6">
                <SGPFormDataComponent
                  name="data_fim"                    
                  placeholder="Data Fim" 
                  :time="false"           
                  v-model="formSeletores.data_fim"
                />
              </div>
            </SGPRowComponent>
            <SGPRowComponent no-gutters>
              <SGPColComponent>
                <SGPFormToggleComponent
                  name="historico_usuario"
                  titulo="Meus Históricos"
                  v-model="formSeletores.historico_usuario"
                />
              </SGPColComponent>
            </SGPRowComponent>
          </SGPFormFilterComponent>
        </template>
      </SGPFiltroComponent>
    </SGPDrawerComponent> -->

  </div>
</template>

<script>
import { formataDataBr } from '@/common/boot/Utils'
import { mapActions, mapGetters } from 'vuex';
import SGPTimelineHistoricoComponent from './SGPTimelineHistoricoComponent.vue';

import criarToast from '@/common/boot/ToastsHandler'
import EventBus from '@/common/helpers/EventBus'


// import ReadonlyFormularioComponent from '@/modules/forms/formularios/components/ReadonlyFormularioComponent'
// import criarToast from '@/common/boot/ToastsHandler'
// import EventBus from '@/common/helpers/EventBus'

export default {
  name: "HistoricoComponent",

  components: {
    SGPTimelineHistoricoComponent,
  },

  props: {
    historico: {
      type: Object,
    },
    circuito: {
      type: Object,
    },
    tarefa: {
      type: Object,
      required: true
    }
  },

  data () { 
    return {
      panel: 0,
      buscaHistorico: '',
      atualizacoesHistorico: false,
      formSeletores: {
        exibir_historico_completo: '',
        historico_usuario: '',
        data_inicio: '',
        data_fim: ''
      },
      abrirFiltroAvancado: false,
      filtroPayload: {},
      filtro: {},
      filterData: [],
      listaDeHistorico: [],
      paginacao: {
        per_page: 10,
        current_page: 1,
        last_page: null
      },
      exibeCarregarMais: false,
      openAll: false
    }
  },

  async created () {    
    this.limparFiltroLocalStorage()
    this.limparDadosHistorico()
    
    EventBus.$on("tratativaAtualizada", this.handleTratativaAtualizada);
    EventBus.$on("salvandoFormularioDinamico", this.limparDadosHistoricoDepoisTratamento);
  },

  beforeDestroy() {
    EventBus.$off("tratativaAtualizada", this.handleTratativaAtualizada);
    EventBus.$off("salvandoFormularioDinamico", this.limparDadosHistoricoDepoisTratamento);
  },

  computed: {
    ...mapGetters('fichaTecnicaWorkflow', [
      'dadosHistoricoFichaTecnica',
      'dadosFichaTecnica',
      'historicoTicket'
    ]),
    ...mapGetters('ctrlProcessos', [
      'listaDeProcessos'
    ]),
    ...mapGetters('ctrlTarefas', ['listaDeTarefasAtivas']),
    ...mapGetters('ctrlTratativas', [
      'listaDeTratativas'
    ]),
    
    // ID do ticket de recuperação
    ticketRecuperacaoId() {
      return this.tarefa?.pco_workflow_id ?? null;
    },

    // Computed para pegar dados do ticket/workflow do histórico
    ticketData() {
      return this.historicoTicket || null;
    },
    camposFiltrosComputed () {
      const campos = []
      if (
          this.listaDeProcessos
        ) {

          campos.push({
            name: 'ctrl_processo_id',
            value: (!this.filtro) ? [] : this.filtro.ctrl_processo_id,
            titulo: 'Macro Processos',
            valueLabel: '',
            type: 'multiplo',
            options: this.listaDeProcessos.filter(item => item.ctrl_processo_id === null).map(item => {
              return { value: item.id, text: item.processo }
            })
          }),

          campos.push({
            name: 'ctrl_tarefa_origem_id',
            value: (!this.filtro) ? [] : this.filtro.ctrl_tarefa_origem_id,
            titulo: 'Tarefa Origem',
            valueLabel: '',
            type: 'auto_complete',
            options: this.listaDeTarefasAtivas
                .filter(item => item.deleted_at == null)
                .map(item => {
              return { value: item.id, text: item.tarefa }
            })

          }),

          campos.push({
            name: 'ctrl_tarefa_destino_id',
            value: (!this.filtro) ? [] : this.filtro.ctrl_tarefa_destino_id,
            titulo: 'Tarefa Destino',
            valueLabel: '',
            type: 'auto_complete',
            options: this.listaDeTarefasAtivas
                .filter(item => item.deleted_at == null)
                .map(item => {
              return { value: item.id, text: item.tarefa }
            })

          }),

          campos.push({
            name: 'ctrl_tratativa_id',
            value: (!this.filtro) ? [] : this.filtro.ctrl_tratativa_id,
            titulo: 'Tratativa',
            valueLabel: '',
            type: 'multiplo',
            options: this.listaDeTratativas
                .filter(item => item.deleted_at == null)
                .map(item => {
              return { value: item.id, text: item.tratativa }
            })

          })
        }
          
      return campos
    },

    tratamentosSanitizados() {
      if (this.historicoTicket?.tratamentos?.data) {
        return this.historicoTicket.tratamentos.data
          .map(tratamento => {
            let macro_processo = tratamento.macro_processo ? tratamento.macro_processo : tratamento.ultimo_macro_processo
            if (tratamento.pco_tratamentos_formularios?.[0]?.dados) {
              let dados = typeof tratamento.pco_tratamentos_formularios[0].dados === 'string' 
                ? JSON.parse(tratamento.pco_tratamentos_formularios[0].dados) 
                : tratamento.pco_tratamentos_formularios[0].dados;
              
              dados = Object.keys(dados).reduce((acc, curr) => {
                if (dados[curr]) {
                  acc[curr] = dados[curr];
                }
                return acc;
              }, {});

              tratamento.pco_tratamentos_formularios[0].dados = dados;
            }

            return {
              ...tratamento,
              macro_processo: macro_processo ? macro_processo : '-',
              open: false,
              anexos: tratamento.anexos || []
            }
          }).sort((a, b) => {
            const dateA = new Date(a.created_at);
            const dateB = new Date(b.created_at);
            return dateB - dateA;
          })
      }

      if (!this.ticketData?.tarefas?.length && !this.ticketData?.ctrlTarefas?.length) {
        return [];
      }

      const tarefasDoTicket = this.ticketData.tarefas ?? this.ticketData.ctrlTarefas ?? [];
      const tratamentos = [];
      
      tarefasDoTicket.forEach(tarefa => {
        
        if (tarefa.tratamentos && tarefa.tratamentos.length > 0) {
          tarefa.tratamentos.forEach(tratamento => {
            
            let pco_tratamentos_formularios = [];
            if (tratamento.pco_tratamentos_formularios?.length) {
              pco_tratamentos_formularios = tratamento.pco_tratamentos_formularios.map(form => {
                if (form.dados) {
                  let dados = typeof form.dados === 'string' ? JSON.parse(form.dados) : form.dados;
                  dados = Object.keys(dados).reduce((acc, curr) => {
                    if (dados[curr] !== null && dados[curr] !== undefined && dados[curr] !== '') {
                      acc[curr] = dados[curr];
                    }
                    return acc;
                  }, {});
                  return {
                    ...form,
                    dados: dados // Manter como objeto, não converter para string
                  };
                }
                return form;
              });
            }

            const tratamentoObj = {
              ...tratamento,
              id: tratamento.id,
              nome: tratamento.user_cadastro?.name || tarefa.usuario_tratamento?.name || 'Sem usuário',
              tratativa: tratamento.ctrl_tratativa?.tratativa || '-',
              tarefa_origem: tarefa.ctrl_tarefa?.tarefa || '-',
              tarefa_destino: null,
              macro_processo: '-',
              ultimo_macro_processo: '-',
              pco_tratamentos_formularios,
              descricao: ['Atualizar', 'Cancelar'].includes(tratamento.ctrl_tratativa?.tratativa) ? tratamento.descricao : null,
              finalized_at: tratamento.finalized_at || tratamento.created_at,
              created_at: tratamento.created_at,
              open: false,
              anexos: tratamento.anexos || []
            };
            
            tratamentos.push(tratamentoObj);
          });
        }
      });

      return tratamentos.sort((a, b) => {
        const dateA = new Date(a.created_at);
        const dateB = new Date(b.created_at);
        return dateB - dateA; // Mais recente primeiro
      });
    }
  },

  methods: {
    formataDataBr,
    ...mapActions('fichaTecnicaWorkflow', [
      'buscarDadosHistoricoFichaTecnica',
      'limparDadosHistorico',
      'buscarDadosFichaTecnica',
      'buscarHistoricoTicket'
    ]),
    ...mapActions('ctrlProcessos', [
      'listarProcessosGestaoProducao',
      'listarMacroProcessos',
    ]),
    ...mapActions("ctrlTarefas", ['listarTarefasComFiltro']),
    ...mapActions("ctrlTratativas", ['listarTratativas']),

    async carregarHistoricoTicket() {
      if (!this.ticketRecuperacaoId) {
        return;
      }

      try {
        await this.buscarHistoricoTicket(this.ticketRecuperacaoId);
      } catch (error) {
        criarToast({
          tipo: 'error',
          mensagem: 'Erro ao carregar histórico do ticket'
        });
      }
    },

    async handleTratativaAtualizada() {
      await this.carregarHistoricoTicket();
    },

    expansionPanelOpenCloseControl () {
      this.panel = this.panel == 0 ? 1 : 0
    },

    search() {
      this.listaDeHistorico = this.tratamentosSanitizados

      if (this.buscaHistorico) {
        this.listaDeHistorico = this.listaDeHistorico.map(h => {
          h.string_search = JSON.stringify(h).toLowerCase()

          return {
            ...h
          }
        }).filter(item => {
          item = item.string_search.toLowerCase().includes(this.buscaHistorico.toLowerCase())
          return item
        })
      }
      
      return this.listaDeHistorico  
    },

    limparFiltroLocalStorage () {      
      if(localStorage.filtroAvancado) {
        localStorage.removeItem('filtroAvancado')
      }
    },

    async carregarMaisHistorico() {
      criarToast({
        tipo: 'info',
        mensagem: 'Todos os tratamentos já foram carregados.'
      })
      this.exibeCarregarMais = false
    },

    async limparDadosHistoricoDepoisTratamento () {
      this.limparPaginacao()
      this.limparDadosHistorico()
      
      // Recarregar histórico do ticket após tratamento
      await this.carregarHistoricoTicket();
    },

    getParamFiltro () {
      if(localStorage.filtroAvancado) {
          this.filtroPayload = JSON.parse(localStorage.filtroAvancado)
          
          if(this.filtro) {
            this.filtroPayload.ctrl_processo_id = this.filtro.ctrl_processo_id
            this.filtroPayload.ctrl_tarefa_destino_id = this.filtro.ctrl_tarefa_destino_id
            this.filtroPayload.ctrl_tarefa_origem_id = this.filtro.ctrl_tarefa_origem_id
            this.filtroPayload.ctrl_tratativa_id = this.filtro.ctrl_tratativa_id
            this.filtroPayload.data_inicio = this.filtro.data_inicio
            this.filtroPayload.data_fim = this.filtro.data_fim
            this.filtroPayload.historico_usuario = this.filtro.historico_usuario
          }

        } else {
          const payload = {          
          ...this.filtro
          }          

          this.filtroPayload = payload    
        }

        if (this.ticketRecuperacaoId) {
          this.filtroPayload.ticket_recuperacao_id = this.ticketRecuperacaoId
        }
        this.filtroPayload.exibir_historico_completo = this.formSeletores.exibir_historico_completo
        this.exibeCarregarMais = false
    },

    limparPaginacao() {
      this.paginacao.current_page = 1
    },

    setFilterLocalStorage (objPayload) {
      localStorage.setItem('filtroAvancado', JSON.stringify(objPayload))
    },
    async aplicarFiltroExibirHistoricoCompleto() {  
      await this.carregarHistoricoTicket();
    },
    async switchExibirHistoricoCompleto() {
      this.limparPaginacao()
      this.formSeletores.exibir_historico_completo = !this.formSeletores.exibir_historico_completo;
      this.atualizacoesHistorico = false;
      this.limparDadosHistorico()
      
      await this.carregarHistoricoTicket();
    },

    abrirFiltroAvancadoHistorico () {
      this.abrirFiltroAvancado = !this.abrirFiltroAvancado
      
      if (!this.listaDeProcessos.length) {
        this.listarProcessosGestaoProducao();
      }

      if (!this.listaDeTarefasAtivas.length) {
        this.listarTarefasComFiltro({
          ativo: 1
        });
      }

      if (!this.listaDeTratativas.length) {
        this.listarTratativas();
      }
    },

    async aplicarFiltro (dados) {
      const payload = this.parseFiltro(dados)
      
      if (this.ticketRecuperacaoId) {
        payload.ticket_recuperacao_id = this.ticketRecuperacaoId
      }
      
      this.filtro = payload
      this.limparDadosHistorico()

      await this.carregarHistoricoTicket();

      this.abrirFiltroAvancado = false
    },

    parseFiltro(dadosFiltro) {
      const dados = dadosFiltro || this.filterData

      if(!dados.length) {
        return
      }

      const valueInit = {}
      const payload = {
        ...dados.reduce((obj, item) => {
          return {...obj, [item.name]: item.value }
        }, valueInit),
        ...this.formSeletores
      }
      return payload
    },

    openAllHistory() {
      this.openAll = !this.openAll

      this.listaDeHistorico = this.listaDeHistorico.map(historico => {
        historico.open = historico.open !== 0 ? 0 : false
        return historico
      })
    },

    async filtrarAtualizacoesDeHistorico() {
      this.atualizacoesHistorico = !this.atualizacoesHistorico;
      this.formSeletores.exibir_historico_completo = false;
      this.limparDadosHistorico()
      
      await this.carregarHistoricoTicket();
    }

  },

  watch: {
    tratamentosSanitizados: {
      handler(val) {
        this.listaDeHistorico = val
      },
      immediate: true
    },

    camposFiltrosComputed (val) {
      this.filterData = val
    },

    'historico.tratamentos' (val) {
      if (val) {
        this.paginacao = {
          per_page: val.per_page,
          current_page: val.current_page,
          last_page: val.last_page
        }
      }
    },

    ticketRecuperacaoId: {
      async handler(newVal) {
        if (newVal) {
          await this.carregarHistoricoTicket();
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">

$primary: #e3262e;

.display-flex {
  display: flex;
  align-items: center;
}

.toogle-historico .v-input__control .v-input__slot>.v-label {
  color: $primary !important;
  font-weight: 700;
  margin-left: 10px;
  font-size: 15px !important;
}

.input-busca-historico fieldset {
  margin-top: 3px !important;
}

.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  background-color: #eee;
}

</style>